var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInternalError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 408,
    viewBox: "0 0 600 408",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 600,
    height: 408,
    rx: 15,
    fill: "#FCF8FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M230.768 212.644V316.49H438.46V212.644H230.768V212.644ZM426.921 304.951H242.306V224.182H426.921V304.951Z",
    fill: "#FF0990"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M386.537 235.721C370.671 235.721 357.69 248.701 357.69 264.567C357.69 280.49 370.671 293.413 386.537 293.413C402.46 293.413 415.383 280.49 415.383 264.567C415.383 248.701 402.46 235.721 386.537 235.721ZM386.537 281.875C377.017 281.875 369.229 274.144 369.229 264.567C369.229 255.047 377.017 247.259 386.537 247.259C396.113 247.259 403.844 255.047 403.844 264.567C403.844 274.144 396.113 281.875 386.537 281.875Z",
    fill: "#FF0990"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M403.844 264.566C403.844 274.143 396.113 281.874 386.536 281.874C377.017 281.874 369.229 274.143 369.229 264.566C369.229 255.047 377.017 247.259 386.536 247.259C396.113 247.259 403.844 255.047 403.844 264.566Z",
    fill: "#FBEBF4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M311.537 241.489C298.845 241.489 288.46 251.874 288.46 264.566C288.46 277.316 298.845 287.643 311.537 287.643C324.287 287.643 334.614 277.316 334.614 264.566C334.614 251.874 324.287 241.489 311.537 241.489ZM311.537 276.105C305.191 276.105 299.998 270.97 299.998 264.566C299.998 258.22 305.191 253.028 311.537 253.028C317.941 253.028 323.075 258.22 323.075 264.566C323.075 270.97 317.941 276.105 311.537 276.105Z",
    fill: "#FF0990"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M323.075 264.566C323.075 270.97 317.94 276.104 311.537 276.104C305.19 276.104 299.998 270.97 299.998 264.566C299.998 258.22 305.19 253.027 311.537 253.027C317.94 253.027 323.075 258.22 323.075 264.566Z",
    fill: "#FBEBF4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M334.614 103.028V149.182H403.845V103.028H334.614ZM392.307 137.644H346.153V114.567H392.307V137.644Z",
    fill: "#FF0990"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M392.306 114.567H346.152V137.644H392.306V114.567Z",
    fill: "#FBEBF4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M392.318 91.5107H380.779V108.818H392.318V91.5107Z",
    fill: "#FF0990"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M357.703 91.5107H346.164V108.818H357.703V91.5107Z",
    fill: "#FF0990"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M248.087 270.357H161.549V166.511H363.472V143.434H375.01V178.049H173.087V258.818H248.087V270.357Z",
    fill: "#FF0990"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M253.857 247.28H242.318V281.896H253.857V247.28Z",
    fill: "#FF0990"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternalError);
export default __webpack_public_path__ + "static/media/internal_error.493b4c31.svg";
export { ForwardRef as ReactComponent };